export { default } from "./component";



// WEBPACK FOOTER //
// ./client/modules/common/components/MaintenanceBanner/index.tsx